/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * MfrmNotification Input Action
 */

export class MfrmNotificationInput implements Msdyn365.IActionInput {
    //   Construct the input needed to run the action

    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `promoCode`;
    public getCacheObjectType = () => 'promoCode';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

//   Create a data model here or import one to capture the response of the action
export interface IMfrmNotificationState {
    notifications: [INotification];
}

export interface INotification {
    id?: number | string | undefined;
    type?: string;
    value?: string | undefined;
    status?: string | undefined;
}

/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new MfrmNotificationInput();
};

/**
 *   Use this function to call your action and process the results as needed
 */
async function action(input: MfrmNotificationInput, ctx: Msdyn365.IActionContext): Promise<INotification[]> {
    // tslint:disable-next-line: no-unnecessary-local-variable
    const notifications: INotification[] = [];
    return notifications;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<INotification>>action,
    //   Give your data action a unique id
    id: 'MfrmNotification',
    input: createInput
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
